// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__307mI","image":"Header_image__2FrYS","name":"Header_name__E8BYZ","info":"Header_info__3P2AQ","infoRow":"Header_infoRow__2zESA"};